export default [
    '733.3 733.3',
    '<path fill="none" stroke="var(--p-icon-globe-color, currentColor)" stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="133.3333" d="M366.7,33.3C450,124.6,497.4,243.1,500,366.7c-2.6,123.6-50,242.1-133.3,333.3 M366.7,33.3 c-83.4,91.3-130.8,209.7-133.3,333.3c2.6,123.6,50,242.1,133.3,333.3 M366.7,33.3c-184.1,0-333.3,149.2-333.3,333.3 C33.3,550.8,182.6,700,366.7,700 M366.7,33.3C550.8,33.3,700,182.6,700,366.7C700,550.8,550.8,700,366.7,700 M50,266.7h633.3 M50,466.7h633.3"/>'
    ]

